import { TimeSlot, TimeSlotAdditionalParams, TimeSlotsApiParams } from '@checkout-v2/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { TIME_SLOTS, TIME_SLOTS_CUSTOM_DATE } from '../checkout-state';

export const LOAD_TIME_SLOTS = '[Checkout] Load time slots';
export const LOAD_TIME_SLOTS_FAIL = '[Checkout] Load time slots fail';
export const LOAD_TIME_SLOTS_SUCCESS = '[Checkout] Load time slots success';
export const RESET_LOADED_TIME_SLOTS = '[Checkout] Reset loaded time slots';

export const SELECT_TIME_SLOTS_ACTIVE_OPTION = '[Checkout] Select time slots active option';
export const RESET_TIME_SLOTS_ACTIVE_OPTION = '[Checkout] Reset time slots active option';

export const SELECT_TIME_SLOTS_CUSTOM_DATE = '[Checkout] Select time slots custom date';
export const RESET_TIME_SLOTS_CUSTOM_DATE = '[Checkout] Reset time slots custom date';

export const LOAD_TIME_SLOTS_FOR_CUSTOM_DATE = '[Checkout] Load time slots for custom date';
export const LOAD_TIME_SLOTS_FOR_CUSTOM_DATE_FAIL = '[Checkout] Load time slots for custom date fail';
export const LOAD_TIME_SLOTS_FOR_CUSTOM_DATE_SUCCESS = '[Checkout] Load time slots for custom date success';
export const RESET_LOADED_TIME_SLOTS_FOR_CUSTOM_DATE = '[Checkout] Reset loaded time slots for custom date';

export class LoadTimeSlots extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_TIME_SLOTS;

  constructor(public payload: TimeSlotsApiParams) {
    super(TIME_SLOTS);
  }
}

export class LoadTimeSlotsFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_TIME_SLOTS_FAIL;

  constructor() {
    super(TIME_SLOTS);
  }
}

export class LoadTimeSlotsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_TIME_SLOTS_SUCCESS;

  constructor(public payload: TimeSlot[]) {
    super(TIME_SLOTS);
  }
}

export class ResetLoadedTimeSlots extends StateUtils.LoaderResetAction {
  readonly type = RESET_LOADED_TIME_SLOTS;

  constructor() {
    super(TIME_SLOTS);
  }
}

export class LoadTimeSlotsForCustomDate extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_TIME_SLOTS_FOR_CUSTOM_DATE;

  constructor(public payload: TimeSlotsApiParams) {
    super(TIME_SLOTS_CUSTOM_DATE);
  }
}

export class LoadTimeSlotsForCustomDateFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_TIME_SLOTS_FOR_CUSTOM_DATE_FAIL;

  constructor() {
    super(TIME_SLOTS_CUSTOM_DATE);
  }
}

export class LoadTimeSlotsForCustomDateSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_TIME_SLOTS_FOR_CUSTOM_DATE_SUCCESS;

  constructor(public payload: TimeSlot[]) {
    super(TIME_SLOTS_CUSTOM_DATE);
  }
}

export class ResetLoadedTimeSlotsForCustomDate extends StateUtils.LoaderResetAction {
  readonly type = RESET_LOADED_TIME_SLOTS_FOR_CUSTOM_DATE;

  constructor() {
    super(TIME_SLOTS_CUSTOM_DATE);
  }
}

export class SelectTimeSlotsActiveOption implements Action {
  readonly type = SELECT_TIME_SLOTS_ACTIVE_OPTION;

  constructor(
    public payload: string,
    public additionalParams?: TimeSlotAdditionalParams,
  ) {}
}

export class ResetTimeSlotsActiveOption implements Action {
  readonly type = RESET_TIME_SLOTS_ACTIVE_OPTION;
}

export class SelectTimeSlotsCustomDate implements Action {
  readonly type = SELECT_TIME_SLOTS_CUSTOM_DATE;

  constructor(public payload: string) {}
}

export class ResetTimeSlotsCustomDate implements Action {
  readonly type = RESET_TIME_SLOTS_CUSTOM_DATE;
}

export type TimeSlotsActions =
  | LoadTimeSlots
  | LoadTimeSlotsSuccess
  | LoadTimeSlotsFail
  | ResetLoadedTimeSlots
  | SelectTimeSlotsActiveOption
  | ResetTimeSlotsActiveOption
  | LoadTimeSlotsForCustomDate
  | LoadTimeSlotsForCustomDateFail
  | LoadTimeSlotsForCustomDateSuccess
  | ResetLoadedTimeSlotsForCustomDate
  | SelectTimeSlotsCustomDate
  | ResetTimeSlotsCustomDate;
